import React from "react";
import { useSelector } from "react-redux";
import AutoTranslate from "../../../../Components/AutoTranslate";

const Step0 = ({ onNext }) => {
  const language = useSelector((state) => state.localStorage.language);

  return (
    <div className='flex-column-center-center gap-5 w-100'>
      <div className='step-form-container'>
        <div className='flex-column-center-center' style={{ height: "100%" }}>
          <h1 className='step-form-title'>
            <AutoTranslate targetLanguage={language.lang}>지금부터 개인 건강 면담을 시작하겠습니다.</AutoTranslate>
          </h1>
        </div>
        <div className='flex-center-center'>
          <button className='step-button step-button-primary' onClick={onNext}>
            <AutoTranslate targetLanguage={language.lang}>시작하기</AutoTranslate>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step0;
